export default "__VITE_ASSET__Us7e6QCp__"